import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../api/apiClient";

export const useApi = (url, params = {}, options = {}) => {
  const { queryKey = [] } = options;
  return useQuery({
    queryKey: [url, ...queryKey],
    queryFn: () =>
      fetchData({
        url,
        params,
        config: options.config,
        method: options.method || "get", // 👈 اینجا مشخص می‌کنی POST یا GET
      }),
    enabled: options.enabled ?? !options.skip,
    onSuccess: options.onSuccess, // ← اضافه کنید
    onError: options.onError, // ← اضافه کنید
    ...options.queryConfig,
  });
};



// queryKey
//queryKey: [medicalSystemId],  